/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { Link } from 'react-router-dom'
import { KTIcon } from '../../../helpers'

const DeskDrawer = () => {
  const data = [
    { id: 1, title: 'My tray inbox sample 01', icon: 'directbox-default', iconColor: 'info', desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
    // { id: 2, title: 'Process A sample 02', icon: 'questionnaire-tablet', iconColor: 'danger', desc: 'Qui modi fuga vero sapiente totam, labore ratione officiis adipisci numquam unde.' },
    { id: 3, title: 'My task sample 03', icon: 'share', iconColor: 'primary', desc: 'Aperiam quaerat ad, dolor inventore sit neque atque itaque amet?' },
    { id: 4, title: 'Library sample 04', icon: 'lots-shopping', iconColor: 'warning', desc: 'Lorem ipsum dolor sit amet consectetur adipisicing ' },
  ];

  return (
    <div
      id='kt_desk'
      className='bg-body'
      data-kt-drawer='true'
      data-kt-drawer-name='desk'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'350px', 'md': '525px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_desk_toggle'
      data-kt-drawer-close='#kt_desk_close'
    >



      {/* begin::Card */}
      <div className='card shadow-none rounded-0 w-100'>
        {/* begin::Header */}
        <div className='card-header' id='kt_desk_header'>
          <h5 className='card-title fw-bold text-gray-600'>Tray</h5>

          <div className='card-toolbar'>
            <button
              type='button'
              className='btn btn-sm btn-icon explore-btn-dismiss me-n5'
              id='kt_desk_close'
            >
              <KTIcon iconName='cross' className='fs-2' />
              <span className='visually-hidden'>Close Tray</span>
            </button>
          </div>
        </div>
        {/* end::Header */}

        {/* begin::Body */}
        <div className='card-body' id='kt_desk_body'>
          {/* begin::Content */}
          <div
            id='kt_desk_scroll'
            className='hover-scroll-overlay-y'
            data-kt-scroll='true'
            data-kt-scroll-height='auto'
            data-kt-scroll-wrappers='#kt_desk_body'
            data-kt-scroll-dependencies='#kt_desk_header'
            data-kt-scroll-offset='5px'
          >


            {data.map(item => (
              <div key={item.id} className='d-flex align-items-center mb-7'>
                <div className={`d-flex flex-center w-50px h-50px w-lg-75px h-lg-75px flex-shrink-0 rounded bg-light-${item.iconColor}`}>
                  <KTIcon iconName={`${item.icon}`} className={`text-${item.iconColor} fs-2x text-lg-3x`} />
                </div>
                <div className='d-flex flex-stack flex-grow-1 ms-4 ms-lg-6'>
                  {/* begin::Wrapper */}
                  <div className='d-flex flex-column me-2 me-lg-5'>
                    {/* begin::Title */}
                    <a
                      href='https://preview.keenthemes.com/metronic8/react/docs/docs/quick-start'
                      className='text-dark text-hover-primary fw-bolder fs-6 fs-lg-4 mb-1'
                    >
                      {item.title}
                    </a>
                    {/* end::Title */}
                    {/* begin::Description */}
                    <div className='text-muted fw-bold fs-7 fs-lg-6'>
                      {item.desc}
                    </div>
                    {/* end::Description */}
                  </div>
                  {/* end::Wrapper */}
                </div>
              </div>
            ))}
          </div>
          {/* end::Content */}
        </div>
        {/* end::Body */}
      </div>
      {/* end::Card */}
    </div>
  )
}

export { DeskDrawer }
